var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.productWrapperClasses},[_vm._t("default")],2),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.displayError),expression:"displayError"}],ref:"error",class:_vm.errorClasses},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }